import CopyLink from "@components/CopyLink/CopyLink";
import SectionHeader from "@components/Section/SectionHeader";
import { useCurrentUserMutation, useGetUser } from "@utils/hooks";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

type DashboardProgressEmployerDetailsProps = {
  progress: "progress" | "done";
};

const DashboardProgressEmployerDetails: React.FC<
  DashboardProgressEmployerDetailsProps
> = ({ progress }) => {
  const { mutate, isSuccess, isLoading } = useCurrentUserMutation();
  const { data } = useGetUser();

  const handleSendViaEmail = () => {
    // todo: flow send via email ( opens user email with predefined email copy and send )

    mutate({
      process_employer_details: "waiting",
    });
  };

  useEffect(() => {
    if (!isLoading && isSuccess) {
      return window.location.reload();
    }
  }, [isLoading, isSuccess]);

  return (
    <div className="flex flex-col gap-y-4">
      <SectionHeader label="Your Penny Pension" />

      <div className="mx-4 sm:mx-8 md:mx-12 lg:mx-16">
        <div className="border border-pn_gray-200 rounded-2xl bg-pn_white flex flex-col p-4 sm:p-6 gap-y-4">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="flex flex-col gap-y-2 flex-1">
              <span className="text-pn-headline-emphasis text-pn_gray-950">
                {progress === "progress"
                  ? "Employer Details"
                  : "Stripe LLC completed their details"}
              </span>
              <span className="text-pn-callout-regular text-pn_gray-600">
                {progress === "progress"
                  ? "Your employer needs to provide us with some important details. Until then, you can't submit your pension application."
                  : `${data?.last_name}, now that your employer confirmed all the required details, its time to complete your application.`}
              </span>
            </div>

            <div className="flex-shrink-0">
              {progress === "progress" ? (
                <CopyLink
                  withButton
                  eventBtn={handleSendViaEmail}
                  btnLabel="Send Via Email"
                  btnVariant="primary"
                  copy="http://penny.com/form"
                  label="Please send this form to your employer"
                />
              ) : (
                <Link
                  to={"/pension-application"}
                  className="btn-primary-lg text-center whitespace-nowrap block w-full sm:w-auto"
                >
                  Complete Application
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DashboardProgressEmployerDetails;
